import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { X, Cookie } from 'lucide-react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const hasConsent = localStorage.getItem('cookie-consent');
    if (!hasConsent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setShowBanner(false);
    
    // Trigger marketing scripts loading
    window.dispatchEvent(new CustomEvent('cookies-accepted'));
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 left-4 z-50 w-80">
      <Card className="bg-white border border-gray-200 shadow-lg">
        <div className="p-4">
          <div className="flex items-start gap-3">
            <Cookie className="h-4 w-4 text-assembly-purple flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <h3 className="text-base font-semibold text-gray-900 mb-1">
                We use cookies to enhance your experience
              </h3>
              <p className="text-gray-600 text-xs mb-3">
                We use cookies for analytics and marketing.{' '}
                <a href="/privacy-policy" className="text-assembly-purple hover:underline">
                  Learn more about our privacy policy
                </a>
              </p>
              <div className="flex gap-2">
                <Button 
                  onClick={handleAccept}
                  size="sm"
                  className="bg-gradient-to-r from-assembly-purple to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white text-xs"
                >
                  Accept All
                </Button>
                <Button 
                  onClick={handleDecline}
                  variant="outline"
                  size="sm"
                  className="border-gray-300 text-gray-700 hover:bg-gray-50 text-xs"
                >
                  Decline
                </Button>
              </div>
            </div>
            <button
              onClick={handleDecline}
              className="text-gray-600 hover:text-gray-800 flex-shrink-0"
              aria-label="Close cookie banner"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default CookieConsent;